// api-status.service.ts
import { Injectable } from '@angular/core';
import { RequestStatus } from '@techextensor/tab-sdk';

@Injectable({
  providedIn: 'root'
})
export class ApiStatusService {
  private maxHistorySize = 5; // Maximum number of stored statuses
  private statusMap: Map<string, RequestStatus> = new Map(); // Key: URL, Value: RequestStatus

  // Set the latest status for a URL (replaces any previous status)
  setLatestStatus(status: RequestStatus): void {
    // Check if the map already has the maximum allowed entries
    if (this.statusMap.size >= this.maxHistorySize) {
      // Remove the oldest entry (the first one inserted in the Map)
      const firstKey = this.statusMap.keys().next().value;
      this.statusMap.delete(firstKey || ''); // Delete the oldest entry
    }

    // Update the map with the new status for the given URL
    this.statusMap.set(status.url, status);
  }

  // Get the latest status for a URL (most recent status)
  getLatestStatus(url: string): RequestStatus | null {
    return this.statusMap.get(url) || null; // Return null if no status exists for the URL
  }

  // Get the status for a specific URL
  getStatusByUrl(url: string): RequestStatus | null {
    return this.statusMap.get(url) || null; // Return null if no status exists for the URL
  }
}
